export default (function joinTourModalInit() {
    const joinTour = {
        setProductId() {
            const productCardQuestion = $('.js--product_card__question');
            const modalJoinTourCategory = $('.js--join_tour_form_category__id_product');

            if (productCardQuestion && productCardQuestion.length) {
                productCardQuestion.on('click', function () {
                    modalJoinTourCategory.val($(this).attr('data-id-product'));
                });
            }
        },
    };
    $(document).ready(() => {
        joinTour.setProductId();
    });
}());
